import { Direction2D, Line2D, Point2D } from '@paragon/geometry-library';
import { roundToIncrement } from '@paragon/utilities';

/** Rounds an angle to the nearest whole degree, snapping to a multiple of 90° when within 5° of one. */
export function snapAngleToDegreesWithOrthogonalBias(angleDegrees: number): number {
  const closestDegree = Math.round(angleDegrees);
  const angleMod90 = Math.abs(closestDegree) % 90;
  const closeTo90 = angleMod90 < 5 || angleMod90 > 85;

  return closeTo90 ? roundToIncrement(closestDegree, 90) : closestDegree;
}

/**
 * Snaps `point` so the segment from `otherPoint` has a whole-degree angle (90°-biased). Preserves the distance from
 *   `otherPoint`.
 */
export function snapSegmentEndpointToWholeDegreeAngle(
  otherPoint: Point2D,
  point: Point2D,
): { snappedAngleDegrees: number; point: Point2D } {
  const currentAngle = Direction2D.right.angleTo(Direction2D.fromPoints(otherPoint, point));
  const snappedAngle = snapAngleToDegreesWithOrthogonalBias(currentAngle);
  const line = new Line2D(otherPoint, Direction2D.fromAngle(snappedAngle));

  return { snappedAngleDegrees: snappedAngle, point: line.getPointAlongLine(otherPoint.distanceTo(point)) };
}
